import React, {Component} from 'react';
import moment from 'moment';
import Avatar from 'react-avatar';

export default class MyAppointment extends Component {
    constructor(props) {
        super(props);
        //this.btnCancel = this.btnCancel.bind(this)

        this.showPopupBeforeCancel = this.showPopupBeforeCancel.bind(this);
    }

    /*btnCancel(e) {
        e.preventDefault();
        this.props.handleCancel(this.props.appointment.id)
    }*/

    showPopupBeforeCancel(e) {
        e.preventDefault();
        this.props.showPopupBeforeCancel();
    }

    onBtnBack(component_name) {
        this.props.handleBtnBack(component_name);
    }

    render() {
        let appointment = this.props.appointment;
        return (
            <div className="smart-forms smart-container wrap-2">
                <div className="form-header header-lite">
                    <h4>My Appointment</h4>
                </div>
                <div className="form-body smart-steps steps-theme-primary">
                    <form method="post" action="#" id="smart-form" novalidate="novalidate">
                        <fieldset>
                            <div className="section colm colm12">
                                <div className="spacer-b0">
                                    <div className="productpicked" style={{"display": "block"}}>
                                        <div className="pricerow">
                                            <div className="itemname">{appointment.service_full_name}</div>
                                            <div className="itemprice">${appointment.price_of_service}</div>
                                        </div>
                                        <div className="pricerow">
                                            <div className="itemname">HST</div>
                                            <div className="itemprice">${appointment.tax}</div>
                                        </div>
                                        {
                                            appointment.credits_used > 0 &&
                                            <div className="pricerow">
                                                <div className="itemname">Promo Code</div>
                                                <div className="itemprice">${appointment.credits_used}</div>
                                            </div>
                                        }

                                    </div>
                                    <div className="thetotals">
                                        <h1 className="page_totals">Total $<span>{appointment.total_price}</span></h1>
                                    </div>
                                    <div className="summary">Order Summary</div>
                                    <div className="orderdetails">
                                        <strong>Appointment
                                            Date: </strong>{moment(appointment.date).format('dddd, MMMM Do YYYY')}<br />
                                        <strong>Location: </strong>{appointment.address + ' ' + appointment.postal_code}<br />
                                        <strong>Time: </strong>{moment(appointment.date).format('LT')}<br />
                                    </div>
                                    <div className="summary">Professional</div>
                                    <div className="name-header">
                                        <Avatar size={60} round={true} src={appointment.professional.profile_image} />
                                        <div className="name-container">
                                            <div
                                                className="orderdetails professional">
                                                {appointment.professional.first_name + ' ' + appointment.professional.last_name}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        appointment.status === 'active' &&
                                        <div>
                                            <div className="appointment-change">
                                                <label className="switch switch-round">
                                                    <span> If you need to change your appointment, email us at
                                                        <a href="mailto:info@gostylu.com"> info@gostylu.com</a>
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="controls">
                                                <div className="sendit">
                                                    <button
                                                        className="button btn-primary"
                                                        onClick={this.showPopupBeforeCancel}
                                                    > CANCEL
                                                    </button>
                                                </div>
                                                <div className="additional-br"></div>
                                            </div>
                                        </div>

                                    }
                                    <div className="text-center backer">
                                        <a
                                            href="#"
                                            className="back"
                                            onClick={this.onBtnBack.bind(this, 'myAppointment')}
                                        >&larr;  Back</a></div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/MyAppointment.js
 **/